// Environment configuration for QA
export const environment = {
  production: true,

  // API Configuration - QA Backend (será substituído pelo workflow)
  apiUrl: 'https://bistback.entretech.co.mz',
  apiTimeout: 30000, // 30 seconds

  // Google Maps API
  googleMapsApiKey: 'AIzaSyAFGo-43FMYgr4x1iYnJJRWDwfPbE2QEYg',
  googleMapsEmbedApiKey: 'AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg',

  // OAuth2 Configuration - QA (usa o mesmo client ID de produção)
  oauth2: {
    google: {
      clientId: '941300541892-i10nou0o7q3u6shcad4imfq49uesc3lu.apps.googleusercontent.com',
      issuer: 'https://accounts.google.com'
    },
    facebook: {
      clientId: 'FACEBOOK_APP_ID', // TODO: Replace with actual Facebook App ID
      loginUrl: 'https://www.facebook.com/v12.0/dialog/oauth'
    },
    apple: {
      clientId: 'APPLE_CLIENT_ID', // TODO: Replace with actual Apple Client ID
      issuer: 'https://appleid.apple.com'
    }
  },

  // Other configurations
  enableDebugInfo: true // Debug habilitado em QA
};

